module.exports = __webpack_public_path__ + "media/images/bg/mosaic/workshops-2af9ebe1090c50bace0f7e82be3fc667.jpg";